import { cn } from '@/lib/utils'

export const CaseStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  return (
    <div
      className={cn(
        'h-5 rounded-md border border-slate-100 bg-slate-50 px-2.5',
        'flex items-center justify-center',
        'whitespace-nowrap text-xs font-bold text-slate-500'
      )}
    >
      {status}
    </div>
  )
}
